import React from 'react';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';

import usePageTitle from '../../hooks/UsePageTitle';
const BusinessSetUp = () => {
  usePageTitle('Business Set Up Services');

  return (
    <div className="page-container">
      <div className="grid">
        <div className="col-12">
          <h1 className="text-center">Business Set Up Services</h1>
          <Divider />
        </div>

        {/* Introduction Section */}
        <div className="col-12 md:col-6">
          <img 
            src='/images/business1.jpg' 
            alt="Business Set Up Services" 
            className="w-full border-round shadow-2 mb-4" 
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          />
        </div>
        <div className="col-12 md:col-6">
          <Card className="h-full">
            <p className="text-lg line-height-3">
              Setting up a new business involves far more than just registering a company name. It is the foundation 
              upon which your future operations, compliance, and growth potential are built.
            </p>
            <p className="text-lg line-height-3 mt-3">
              At SnP Finvisors, our Business Set Up Service is meticulously designed to offer end-to-end support, 
              helping entrepreneurs and enterprises establish their business with clarity, confidence, and compliance.
            </p>
          </Card>
        </div>

        {/* Why Business Set Up Matters Section */}
        <div className="col-12 mt-5">
          <Card>
            <h2>Why Business Set Up Services Matter</h2>
            <Divider />
            <p className="text-lg line-height-3">
              A well-structured business setup ensures operational efficiency, regulatory compliance, and optimal 
              tax structuring from the very beginning. Any oversight at this stage can lead to legal, financial, 
              and administrative roadblocks down the line.
            </p>
            <p className="text-lg line-height-3 mt-3 font-semibold">
              Our expert team works closely with clients to navigate the complexities of incorporation, 
              statutory registrations, policy formulation, and more.
            </p>
          </Card>
        </div>

        {/* Services Section */}
        <div className="col-12 mt-5">
          <h2>Our Business Set Up Offerings</h2>
          <Divider />
          
          <div className="grid">
            {/* Service 1 */}
            <div className="col-12 md:col-6">
              <Card title="1. Entity Selection & Structuring" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Assistance in choosing the right business structure (Private Limited Company, LLP, Partnership Firm, etc.)</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Evaluation of pros and cons for each type of entity to align with your business vision</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 2 */}
            <div className="col-12 md:col-6">
              <Card title="2. Company Incorporation" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Name reservation and DSC registration</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Filing of incorporation forms with MCA</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Drafting of MoA and AoA</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 3 */}
            <div className="col-12 md:col-6">
              <Card title="3. Regulatory & Statutory Registrations" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Registration under GST, PF, ESI, Professional Tax</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>MSME, IEC, and FSSAI registration where applicable</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 4 */}
            <div className="col-12 md:col-6">
              <Card title="4. Banking and Operational Set-Up" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Assistance in opening corporate bank accounts</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Advising on banking partners and digital payment solutions</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 5 */}
            <div className="col-12 md:col-6">
              <Card title="5. Initial Financial & Tax Setup" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Setting up basic accounting systems and ERP</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Advisory on TDS, advance tax, and statutory due dates</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 6 */}
            <div className="col-12 md:col-6">
              <Card title="6. Legal Documentation" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Drafting partnership deeds, shareholders' agreements</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Ensuring compliance with labor laws and regulations</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 7 */}
            <div className="col-12 md:col-6">
              <Card title="7. Licensing & Industry-Specific Compliances" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Acquisition of licenses for specific industries</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Environmental clearances and trade licenses</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 8 */}
            <div className="col-12 md:col-6">
              <Card title="8. Post-Incorporation Compliance" className="mb-4 h-full">
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Guidance on ROC filings and board resolutions</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Timely reminders for filing of various returns</span>
                  </li>
                </ul>
              </Card>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="col-12 mt-5">
          <Card>
            <h2>Benefits of Our Business Set Up Services</h2>
            <Divider />
            <div className="grid">
              <div className="col-12 md:col-6">
                <ul className="list-none p-0 m-0">
                  <li className="mb-3 flex align-items-start">
                    <i className="pi pi-star-fill text-primary mr-2 mt-1"></i>
                    <span className="font-semibold">Single Window Support:</span> We handle all aspects under one roof
                  </li>
                  <li className="mb-3 flex align-items-start">
                    <i className="pi pi-star-fill text-primary mr-2 mt-1"></i>
                    <span className="font-semibold">Expert Guidance:</span> Deep expertise in corporate law and finance
                  </li>
                  <li className="mb-3 flex align-items-start">
                    <i className="pi pi-star-fill text-primary mr-2 mt-1"></i>
                    <span className="font-semibold">Speed & Accuracy:</span> Timely execution without compromising accuracy
                  </li>
                </ul>
              </div>
              <div className="col-12 md:col-6">
                <ul className="list-none p-0 m-0">
                  <li className="mb-3 flex align-items-start">
                    <i className="pi pi-star-fill text-primary mr-2 mt-1"></i>
                    <span className="font-semibold">Customized Approach:</span> Tailored to your business model
                  </li>
                  <li className="mb-3 flex align-items-start">
                    <i className="pi pi-star-fill text-primary mr-2 mt-1"></i>
                    <span className="font-semibold">Continued Support:</span> Your trusted partners beyond setup
                  </li>
                </ul>
              </div>
            </div>
          </Card>
        </div>

        {/* Who Can Benefit Section */}
        <div className="col-12 mt-5">
          <Card>
            <h2>Who Can Benefit?</h2>
            <Divider />
            <div className="grid">
              <div className="col-12 md:col-3 text-center">
                <i className="pi pi-user-plus text-4xl text-primary"></i>
                <p className="font-semibold mt-2">First-time entrepreneurs</p>
              </div>
              <div className="col-12 md:col-3 text-center">
                <i className="pi pi-rocket text-4xl text-primary"></i>
                <p className="font-semibold mt-2">Startups</p>
              </div>
              <div className="col-12 md:col-3 text-center">
                <i className="pi pi-globe text-4xl text-primary"></i>
                <p className="font-semibold mt-2">International businesses</p>
              </div>
              <div className="col-12 md:col-3 text-center">
                <i className="pi pi-building text-4xl text-primary"></i>
                <p className="font-semibold mt-2">Established companies</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Closing Section */}
        <div className="col-12 mt-5">
          <Card className="surface-100">
            <div className="grid">
              <div className="col-12 md:col-8">
                <h2 className="mt-0">Get Your Business Started the Right Way</h2>
                <Divider />
                <p className="text-xl line-height-3">
                  The success of your business journey begins with how you start. SnP Finvisors ensures that every 
                  foundation stone is carefully placed so that your enterprise stands tall in the years to come.
                </p>
                <p className="text-xl line-height-3 mt-3 font-semibold">
                  Reach out to us for a free consultation, and let's build your business together—strategically, 
                  smartly, and smoothly.
                </p>
              </div>
              <div className="col-12 md:col-4">
                <img 
                  src='/images/b2.png' 
                  alt="Business Consultation" 
                  className="w-full border-round" 
                  style={{ maxHeight: '250px', objectFit: 'cover' }}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default BusinessSetUp;